import React from 'react'
import { addNotifications } from '../../../../toaster/ToasterPortalSlice';
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, setUploadedFile } from '../BulkUploadSlice'
import { getTemplate, uploadSheet } from '../BulkUploadSaga'
import FileUpload from '../../../../../components/fileupload/FileUpload'

export default function UploadFile() {

    const { uploadedFile } = useSelector((state) => state[componentKey]);
    const dispatch = useDispatch();

    const handleFileUpload = (event) => {
        event.preventDefault();
        const file = event.target.files[0];
        const allowedFileTypes = ['.xls', '.xlsx', '.csv'];
        const fileExtension = file.name.split('.').pop().toLowerCase();

        if (allowedFileTypes.includes(`.${fileExtension}`)) {
            dispatch(setUploadedFile(file));
            if (file) {
                dispatch(uploadSheet(file));
            }
        } else {
            dispatch(addNotifications({ heading: "File format not supported", message: "Invalid file format. Please upload a .xlsx or .csv file." }));
        }
        event.target.value = null;
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        const allowedFileTypes = ['.xls', '.xlsx', '.csv'];
        const fileExtension = file.name.split('.').pop().toLowerCase();

        if (allowedFileTypes.includes(`.${fileExtension}`)) {
            dispatch(setUploadedFile(file));
            if (file) {
                dispatch(uploadSheet(file));
            }
        } else {
            dispatch(addNotifications({ heading: "File format not supported", message: "Invalid file format. Please upload a .xlsx or .csv file." }));
        }
    };

    return (
        <FileUpload
            uploadedFile={uploadedFile}
            onDropCb={handleDrop}
            templatesForDownload={[
                {
                    templateText: "Download Template",
                    downloadTemplateCb: () => dispatch(getTemplate()),
                },
            ]}
            onInputChangeCb={handleFileUpload}
        />
    )
}